import script from "./NewMixView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMixView.vue?vue&type=script&setup=true&lang=js"

import "./NewMixView.vue?vue&type=style&index=0&id=7151099a&lang=css"

const __exports__ = script;

export default __exports__